import { createClient } from "@supabase/supabase-js";
export const supabaseUrl = 'https://xzvffrsiaabeljbjqial.supabase.co';
export const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh6dmZmcnNpYWFiZWxqYmpxaWFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzNDYyOTMsImV4cCI6MjA4OTkyMjI5M30.2-bWm-PlWpBqN7pI45qfg0Baz72qBFuT9-Vyxwj1NhU';


export const supabase = createClient(supabaseUrl, supabaseKey);